"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _system = require("@mui/system");
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("../../components/Checkbox"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _FormModal = _interopRequireDefault(require("./FormModal"));
var Theme = _interopRequireWildcard(require("../../theme/index"));
var session = _interopRequireWildcard(require("../../services/session"));
var _constants = require("../../services/constants");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FullScreenBlock = (0, _system.styled)("div")(function (_ref) {
  var theme = _ref.theme;
  return (0, _defineProperty2["default"])({
    display: 'block'
  }, theme.breakpoints.down(750), {
    display: 'none'
  });
});
var MobileColumn = (0, _system.styled)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return (0, _defineProperty2["default"])({
    display: 'none'
  }, theme.breakpoints.down(750), {
    display: 'block',
    width: '100%'
  });
});

/**
 * @param classes
 * @returns {*}
 * @constructor
 */
var LsaSelectionModal = /*#__PURE__*/function (_Component) {
  function LsaSelectionModal() {
    var _this;
    (0, _classCallCheck2["default"])(this, LsaSelectionModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, LsaSelectionModal, [].concat(args)), _this.state = {
      selectedItems: null
    }, _this._categorizeItems = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(items) {
        var data, promises;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                Health: [],
                Alternative: [],
                Cosmetic: [],
                Personal: [],
                FitnessAndSports: [],
                Other: []
              };
              if (items) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", data);
            case 3:
              // eslint-disable-next-line array-callback-return
              promises = items.map(function (item) {
                if (_constants.lsaOptions.Health.includes(item)) {
                  data.Health.push(item);
                } else if (_constants.lsaOptions.Alternative.includes(item)) {
                  data.Alternative.push(item);
                } else if (_constants.lsaOptions.Cosmetic.includes(item)) {
                  data.Cosmetic.push(item);
                } else if (_constants.lsaOptions.Personal.includes(item)) {
                  data.Personal.push(item);
                } else if (_constants.lsaOptions.FitnessAndSports.includes(item)) {
                  data.FitnessAndSports.push(item);
                } else {
                  data.Other.push(item);
                }
              });
              _context.next = 6;
              return Promise.all(promises);
            case 6:
              return _context.abrupt("return", data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }(), _this._selectLsaItem = function (parent, item) {
      var selectedItems = _this.state.selectedItems;
      if (!item) {
        if (!selectedItems[parent].length) {
          _this.setState({
            selectedItems: _objectSpread(_objectSpread({}, selectedItems), {}, (0, _defineProperty2["default"])({}, parent, _constants.lsaOptions[parent]))
          });
        } else {
          _this.setState({
            selectedItems: _objectSpread(_objectSpread({}, selectedItems), {}, (0, _defineProperty2["default"])({}, parent, []))
          });
        }
      } else {
        var unique = !selectedItems[parent].includes(item);
        _this.setState({
          selectedItems: _objectSpread(_objectSpread({}, selectedItems), {}, (0, _defineProperty2["default"])({}, parent, unique ? [item].concat((0, _toConsumableArray2["default"])(selectedItems[parent])) : (0, _toConsumableArray2["default"])(selectedItems[parent].filter(function (x) {
            return x !== item;
          }))))
        });
      }
    }, _this._onSave = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var selectedItems, lsaItems, items, success;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            selectedItems = _this.state.selectedItems;
            lsaItems = [];
            Object.keys(selectedItems).map(function (key) {
              return lsaItems.push(selectedItems[key]);
            });
            items = lsaItems.flat();
            if (items.length) {
              _context2.next = 7;
              break;
            }
            alert(_i18n["default"].t(_tokens["default"].labels.validation.oneChoice));
            return _context2.abrupt("return", false);
          case 7:
            _context2.next = 9;
            return _this.props.onSave(items);
          case 9:
            success = _context2.sent;
            if (success) {
              _this._onClose();
            }
            return _context2.abrupt("return", true);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._onClose = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!_this.props.isMasterApp) {
              _context3.next = 3;
              break;
            }
            _context3.next = 3;
            return session.saveLsaOptions(_this.state.selectedItems);
          case 3:
            _this.props.close();
            return _context3.abrupt("return", true);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(LsaSelectionModal, _Component);
  return (0, _createClass2["default"])(LsaSelectionModal, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var _this2 = this;
        var selectedItems;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = this.props.items;
              if (_context5.t0) {
                _context5.next = 5;
                break;
              }
              _context5.next = 4;
              return this.props.getItems();
            case 4:
              _context5.t0 = _context5.sent;
            case 5:
              selectedItems = _context5.t0;
              if (!(!selectedItems || !selectedItems.Health)) {
                _context5.next = 10;
                break;
              }
              _context5.next = 9;
              return this._categorizeItems(selectedItems);
            case 9:
              selectedItems = _context5.sent;
            case 10:
              this.setState({
                selectedItems: selectedItems
              });
              if (this.props.isMasterApp) {
                setInterval( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
                  return _regenerator["default"].wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return session.saveLsaOptions(_this2.state.selectedItems);
                      case 2:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                })), 30000);
              }
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _selectedItems$Health,
        _this3 = this,
        _selectedItems$Altern,
        _selectedItems$Cosmet,
        _selectedItems$Person,
        _selectedItems$Fitnes,
        _selectedItems$Other;
      var open = this.props.open;
      var selectedItems = this.state.selectedItems;
      if (!this.state.selectedItems) {
        return null;
      }
      var styles = {
        lsaOptionsTitleRow: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          borderBottom: "1px solid ".concat(Theme.colors.lightGrey),
          marginTop: 20
        },
        lsaColumn: {
          width: '34%'
        },
        lsaOptionRow: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: 20
        },
        lsaColumnMobileTitle: {
          width: '100%',
          borderBottom: "1px solid ".concat(Theme.colors.lightGrey),
          marginTop: 20
        },
        lsaColumnMobile: {
          width: '100%',
          marginBottom: 20
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.spendingAccounts.lifestyleSpendingAccount),
        testid: "lsa-details-modal",
        maxWidth: false,
        open: open,
        close: this._onClose,
        onBack: this._onClose,
        onSave: this._onSave,
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons.save),
        customContainerStyle: {
          maxWidth: "1066px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _i18n["default"].t(_tokens["default"].labels.masterApplication.lifestyleSpendingAccount)), /*#__PURE__*/_react["default"].createElement(FullScreenBlock, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.lsaOptionsTitleRow
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        sx: styles.lsaColumn,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: Boolean((_selectedItems$Health = selectedItems.Health) === null || _selectedItems$Health === void 0 ? void 0 : _selectedItems$Health.length),
          onChange: function onChange() {
            return _this3._selectLsaItem('Health', '');
          },
          value: "Health",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          bold: true
        }, _i18n["default"].t(_tokens["default"].labels.health))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        sx: styles.lsaColumn,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: Boolean((_selectedItems$Altern = selectedItems.Alternative) === null || _selectedItems$Altern === void 0 ? void 0 : _selectedItems$Altern.length),
          onChange: function onChange() {
            return _this3._selectLsaItem("Alternative", '');
          },
          value: "Alternative",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          bold: true
        }, _i18n["default"].t(_tokens["default"].labels.lsaModal.alternativePractitioner))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        sx: styles.lsaColumn,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: Boolean((_selectedItems$Cosmet = selectedItems.Cosmetic) === null || _selectedItems$Cosmet === void 0 ? void 0 : _selectedItems$Cosmet.length),
          onChange: function onChange() {
            return _this3._selectLsaItem("Cosmetic", '');
          },
          value: "Cosmetic",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          bold: true
        }, _i18n["default"].t(_tokens["default"].labels.lsaModal.cosmetic))
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.lsaOptionRow
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        sx: styles.lsaColumn
      }, _constants.lsaOptions.Health.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          key: item,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: selectedItems.Health.includes(item),
            onChange: function onChange() {
              return _this3._selectLsaItem("Health", item);
            },
            value: item,
            color: "secondary"
          }),
          label: localizationMaps.fromEnglish("benefits", item)
        });
      })), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        sx: styles.lsaColumn
      }, _constants.lsaOptions.Alternative.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          key: item,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: selectedItems.Alternative.includes(item),
            onChange: function onChange() {
              return _this3._selectLsaItem("Alternative", item);
            },
            value: item,
            color: "secondary"
          }),
          label: localizationMaps.fromEnglish("benefits", item)
        });
      })), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        sx: styles.lsaColumn
      }, _constants.lsaOptions.Cosmetic.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          key: item,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: selectedItems.Cosmetic.includes(item),
            onChange: function onChange() {
              return _this3._selectLsaItem("Cosmetic", item);
            },
            value: item,
            color: "secondary"
          }),
          label: localizationMaps.fromEnglish("benefits", item)
        });
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.lsaOptionsTitleRow
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        sx: styles.lsaColumn,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: Boolean((_selectedItems$Person = selectedItems.Personal) === null || _selectedItems$Person === void 0 ? void 0 : _selectedItems$Person.length),
          onChange: function onChange() {
            return _this3._selectLsaItem('Personal', '');
          },
          value: "Personal",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          bold: true
        }, _i18n["default"].t(_tokens["default"].labels.lsaModal.personal))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        sx: styles.lsaColumn,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: Boolean((_selectedItems$Fitnes = selectedItems.FitnessAndSports) === null || _selectedItems$Fitnes === void 0 ? void 0 : _selectedItems$Fitnes.length),
          onChange: function onChange() {
            return _this3._selectLsaItem("FitnessAndSports", '');
          },
          value: "FitnessAndSports",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          bold: true
        }, _i18n["default"].t(_tokens["default"].labels.lsaModal.fitnessAndSports))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        sx: styles.lsaColumn,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: Boolean((_selectedItems$Other = selectedItems.Other) === null || _selectedItems$Other === void 0 ? void 0 : _selectedItems$Other.length),
          onChange: function onChange() {
            return _this3._selectLsaItem("Other", '');
          },
          value: "Other",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          bold: true
        }, _i18n["default"].t(_tokens["default"].labels.account.other))
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.lsaOptionRow
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        sx: styles.lsaColumn
      }, _constants.lsaOptions.Personal.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          key: item,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: selectedItems.Personal.includes(item),
            onChange: function onChange() {
              return _this3._selectLsaItem("Personal", item);
            },
            value: item,
            color: "secondary"
          }),
          label: localizationMaps.fromEnglish("benefits", item)
        });
      })), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        sx: styles.lsaColumn
      }, _constants.lsaOptions.FitnessAndSports.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          key: item,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: selectedItems.FitnessAndSports.includes(item),
            onChange: function onChange() {
              return _this3._selectLsaItem("FitnessAndSports", item);
            },
            value: item,
            color: "secondary"
          }),
          label: localizationMaps.fromEnglish("benefits", item)
        });
      })), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        sx: styles.lsaColumn
      }, _constants.lsaOptions.Other.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          key: item,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: selectedItems.Other.includes(item),
            onChange: function onChange() {
              return _this3._selectLsaItem("Other", item);
            },
            value: item,
            color: "secondary"
          }),
          label: localizationMaps.fromEnglish("benefits", item)
        });
      })))), /*#__PURE__*/_react["default"].createElement(MobileColumn, null, Object.keys(_constants.lsaOptions).map(function (item) {
        var _selectedItems$item;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item,
          style: styles.mobileSection
        }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          sx: styles.lsaColumnMobileTitle,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: Boolean((_selectedItems$item = selectedItems[item]) === null || _selectedItems$item === void 0 ? void 0 : _selectedItems$item.length),
            onChange: function onChange() {
              return _this3._selectLsaItem(item, '');
            },
            value: item,
            color: "secondary"
          }),
          label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
            bold: true
          }, localizationMaps.fromEnglish("benefits", item))
        }), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
          sx: styles.lsaColumnMobile
        }, _constants.lsaOptions[item].map(function (subitem) {
          return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
            key: subitem,
            control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
              checked: selectedItems[item].includes(subitem),
              onChange: function onChange() {
                return _this3._selectLsaItem(item, subitem);
              },
              value: subitem,
              color: "secondary"
            }),
            label: localizationMaps.fromEnglish("benefits", item)
          });
        })));
      })));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = LsaSelectionModal;